import React, { ReactElement } from 'react';
import styles from './HeaderBlock.module.scss';
import { IEvent } from "@common/redux/types/event";
import { ISrcSet } from "@kursk/components/ui/Picture/Picture";
import { ImageWithInfo } from "@kursk/components/ui/ImageWithInfo/ImageWithInfo";
import { Description } from './Description/Description';

interface IProps {
  entity: IEvent;
}

export const HeaderBlock = ({
  entity,
}: IProps): ReactElement => {

  const srcSet: ISrcSet[] = [
    {
      media: "(min-width: 1200px)",
      width: 384,
      height: 256,
    },
    {
      media: "(min-width: 768px) and (max-width: 1199px)",
      width: 384,
      height: 256,
    },
    {
      media: "(max-width: 767px)",
      width: 384,
      height: 256,
    },
  ];

  const name = entity?.name || '';
  const ageRestriction = 'ageRestriction' in entity ? entity.ageRestriction : null;
  const hasAgeRestriction = ageRestriction || ageRestriction === 0;
  const category = 'category' in entity ? entity.category : null;
  const image = entity?.image;

  return (
    <div className={styles.wrapper}>
      <div className={styles.main}>
        <div className={styles.infoWrapper}>
          <div>
            <div className={styles.type}>
              <span>
                {category?.name ? category.name : 'События'}
              </span>
              {hasAgeRestriction && (<span className={styles.age}>
                {ageRestriction}+
              </span>)}
            </div>
            <h1 className={styles.title}>
              {name}
            </h1>
            <div className={styles.description}>
              <Description content={entity.content}/>
            </div>
          </div>
        </div>
        <div className={styles.imgWrapper}>
          <ImageWithInfo image={image} srcSet={srcSet}/>
        </div>
      </div>
    </div>
  )
}
